import { render, staticRenderFns } from "./LoadInputs.vue?vue&type=template&id=9dde01b4&scoped=true&"
import script from "./LoadInputs.vue?vue&type=script&lang=js&"
export * from "./LoadInputs.vue?vue&type=script&lang=js&"
import style0 from "./LoadInputs.vue?vue&type=style&index=0&id=9dde01b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dde01b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dde01b4')) {
      api.createRecord('9dde01b4', component.options)
    } else {
      api.reload('9dde01b4', component.options)
    }
    module.hot.accept("./LoadInputs.vue?vue&type=template&id=9dde01b4&scoped=true&", function () {
      api.rerender('9dde01b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Capacities/LoadInputs.vue"
export default component.exports